import React, {useCallback, useMemo} from 'react';
import {ChangeFunction, Props} from './model';
import {reduxForm} from 'redux-form';
import {Forms} from '../../../models/forms';
import {storage} from '../../../storage';
import {visuallyImpairedSettingsToStorageKey} from '../wrapper';
import {useDispatch, useSelector} from 'react-redux';
import {changeThemeProperty} from '../../../../redux/actions/runtime/theme';
import {themeSelector} from '../../../../redux/selectors/runtime/theme';

export const VisuallyImpairedForm = <T = {}>({render, props = {} as T}: Props<T>) => {
  const View = render;
  const dispatch = useDispatch();
  const themeSettings = useSelector(themeSelector());

  const onChangeValue = useCallback<ChangeFunction>(
    async (key, value) => {
      const storageKey = visuallyImpairedSettingsToStorageKey(key);
      if (storageKey !== null) {
        dispatch(changeThemeProperty(key, value));
      }
    },
    [storage],
  );

  const Form = useMemo(
    () =>
      reduxForm<any, T>({
        initialValues: themeSettings,
        form: Forms.visuallyImpaired,
        destroyOnUnmount: false,
        onChange: async (values, _d, _p, previousValues) => {
          for (const key in values) {
            const value = values[key];
            if (previousValues[key] !== value) {
              // @ts-ignore ToDo:
              await onChangeValue(key, value);
            }
          }
        },
        // @ts-ignore ToDo:
      })(View),
    [View, onChangeValue],
  );
  return React.createElement(Form, props);
};
